import { Component } from '@verndale/core';
import { ExtendedWindowType } from '../coveo/engine';

class CertificationsModal extends Component {
  setupDefaults() {
    this.dom = {
      el: this.el
    };
  }

  addListeners() {
    (this.dom.el as HTMLDialogElement).addEventListener(
      'close',
      this.handleClose.bind(this)
    );
  }

  handleClose() {
    const global = window as ExtendedWindowType;

    global.dataLayer?.push({
      event: 'modal_close',
      event_category: 'modal overlay',
      event_action: 'close',
      event_attributes: {
        modalName: 'certifications'
      }
    });
  }
}

export default CertificationsModal;
